import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HlmSidebarInset } from '@spartan-ng/helm/sidebar';
import { filter, map, startWith } from 'rxjs';
import { AppHeaderComponent } from './app-header.component';
import { AppSidebarComponent } from './app-sidebar.component';

@Component({
    selector: 'app-shell',
    templateUrl: './app-shell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, HlmSidebarInset, AppHeaderComponent, AppSidebarComponent],
})
export class AppShellComponent {
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    protected readonly pageTitle = toSignal(
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            map(() => this.resolvePageTitle()),
            startWith(this.resolvePageTitle()),
        ),
        { initialValue: 'Portál' },
    );

    private resolvePageTitle(): string {
        let route: ActivatedRouteSnapshot | null = this.activatedRoute.snapshot;
        let title = 'Portál';

        while (route) {
            if (typeof route.data?.['title'] === 'string') {
                title = route.data['title'];
            }
            route = route.firstChild;
        }

        return title.split('|', 1)[0].trim() || 'Portál';
    }
}
